import React, { useState } from 'react';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { Done } from '@material-ui/icons';

import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import FilterArticle from 'hooks/FilterArticle';

const columns = [
  { Header: '#', accessor: 'id', width: 80 },
  { Header: 'Código', accessor: 'ItemCode', width: 120 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Cód. proveedor', accessor: 'CardCode', width: 140 },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Nombre categoría', accessor: 'logi_category_description' },
  { Header: 'Nombre familia', accessor: 'logi_family_description' },
  { Header: 'Línea', accessor: 'logi_line_description' },
  { Header: 'Estado', accessor: 'state', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ModalFilterProduct(props) {
  const { children, open, setOpen, entity, filterCustom = {}, setProductSelect } = props;

  const [products, setProducts] = useState([]);

  const handleClose = () => {
    setOpen(false);
    setProducts([]);
  };

  return (
    <ModalFull title="Filtro de Productos" open={open} setOpen={handleClose}>
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <FilterArticle
                getArticleFiltereds={setProducts}
                entity={entity}
                paramFilter={filterCustom}
                mark
              >
                {children}
              </FilterArticle>
            </GridItem>
          </GridContainer>

          <ReactTable
            defaultWidth={1100}
            exportExcel={false}
            columns={columns}
            data={products.map((product, i) => {
              return {
                id: (
                  <div className="actions-right">
                    {i + 1}
                    <Button
                      justIcon
                      size="sm"
                      round
                      color={props.themeContext.buttonColorSuccess}
                      onClick={() => {
                        setProductSelect(product);
                        handleClose();
                      }}
                      style={{ marginLeft: '8px' }}
                    >
                      <Done />
                    </Button>
                  </div>
                ),
                ItemCode: product.ItemCode,
                ItemName: product.ItemName,
                CardCode: product.CardCode,
                CardName: product.CardName,
                logi_category_description: product.logi_category_description,
                logi_family_description: product.logi_family_description,
                logi_line_description: product.logi_line_description,
                state: product.state === 'A' ? 'Activo' : 'Inactivo',
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </ModalFull>
  );
});
